import { useEffect, useState } from 'react';

import { updateStateAttribute } from '../helpers/helper';

interface State {
  scrollX: number;
  scrollY: number;
}

interface Props {
  target?: 'window' | 'document';
  useCapture?: boolean;
  onScroll?: (ev: Event) => void;
}

export const useScroll = ({ target = 'window', useCapture = false, onScroll }: Props = {}): State => {
  const [state, setState] = useState<State>({
    scrollX: 0,
    scrollY: 0
  });

  useEffect(() => {
    const handleScroll = (ev: Event) => {
      if (target === 'window') {
        updateStateAttribute({ scrollX: window.scrollX, scrollY: window.scrollY }, setState);
      } else {
        updateStateAttribute(
          { scrollX: document.documentElement.scrollLeft, scrollY: document.documentElement.scrollTop },
          setState
        );
      }

      if (onScroll) onScroll(ev);
    };

    const eventTarget = target === 'window' ? window : document;
    const options = target === 'document' ? { capture: useCapture } : undefined;

    eventTarget.addEventListener('scroll', handleScroll, options);
    return () => {
      eventTarget.removeEventListener('scroll', handleScroll, options);
    };
  }, [target, useCapture, onScroll]);

  return state;
};
